<template>
    <div
        class="block"
        @contextmenu.prevent="opportunity.contextMenu($event)"
        @click.prevent="opportunity.open()"
    >
        <v-spa-panel class="flex items-center group !px-0 !py-4 cursor-pointer">
            <div class="px-6 w-[300px]">
                <p class="mb-1">{{ opportunity.title }}</p>
                <p class="text-sm text-gray-500">{{ opportunity.added_at | moment().format('DD MMMM YYYY') }}</p>
            </div>
            <div class="px-6 w-[300px]">
                <p>{{ opportunity.getContactName() }}</p>
            </div>
            <div class="px-6 w-[160px]">
                <users-list-avatar :users="opportunity.getManagers()"></users-list-avatar>
            </div>
            <div class="flex space-x-4 px-6 w-[200px]">
                <p>{{ opportunity.total_quoted | price }}</p>
            </div>
            <div class="flex space-x-4 px-6 w-[200px]">
                <div class="flex items-center text-sm space-x-1 text-[#77BB5A]" v-if="opportunity.worksites && opportunity.worksites.length > 0">
                    <i class="text-sm fal fa-check-circle" />
                    <span>{{ $t('opportunitites.archives.transformed_to_worksite') }}</span>
                </div>
            </div>
            <div class="flex justify-end flex-1 px-6">
                <v-spa-submenu-container class="h-full" :container="$spa.css.submenu.container.default" position="right-0" :ref="`opportunityActionsSubmenu-${opportunity.uuid}`">
                    <template v-slot:default="slotProps">
                        <div class="flex items-center justify-center h-full px-4 py-2 text-gray-600 cursor-pointer hover:text-black" @click.stop.prevent="slotProps.toggle()">
                            <i class="text-sm fas fa-ellipsis-h" />
                        </div>
                    </template>
                    
                    <template v-slot:submenu>
                        <div class="relative w-auto" :container="$spa.css.submenu.container.default">
                            <actions :model="opportunity" @close="$refs.submenu.hide()" />
                        </div>
                    </template>
                </v-spa-submenu-container>
                <!-- <router-link :to="{name: 'account.opportunity.homepage', params: {account: $store.state.account.uuid, opportunity: opportunity.uuid}}">
                    <i class="text-xl text-gray-700 far fa-eye hover:text-black"></i>
                </router-link> -->
            </div>
        </v-spa-panel>
    </div>
</template>

<script>
    import UsersListAvatar from '@spa/apps/trustup-pro-base-js/components/_Partials/UsersListAvatar';
    import Actions from './Actions';
    
    export default {
        components: {
            UsersListAvatar,
            Actions,
        },
        props: {
            opportunity: {
                type: Object,
                required: true
            }
        }
    }
</script>